import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '@style/global.scss';
import { Home } from '@pages/Home';
import { initializeI18n } from '@i18n/index';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@lib/queryClient';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  const [isInitializedI18n, setIsInitializedI18n] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      // 多言語
      await initializeI18n();
      setIsInitializedI18n(true);
    };

    initialize();
  }, []);

  if (!isInitializedI18n) {
    return null;
  }

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
